import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

export default class AdqRequest extends CrudRequest {
  static baseUrl() {
    return '/contacardcommon/pendency';
  }

  static save(payload = {}) {
    return httpService.post(
      `${this.baseUrl()}/contrato-adq`,
      payload,
    );
  }

  static infoSgv(document, params = {}) {
    return httpService.get(
      `cliente/loja/loja-sgv-by-document/${document}`,
      {
        params,
      },
    );
  }

  static listSegments(params = {}) {
    return httpService.get(
      'sgrintegration/simulador/segmento',
      {
        params,
      },
    );
  }

  static getMccBySegment(segmentId) {
    return httpService.get(
      'sgrintegration/simulador/relacao/segmento-x-mcc',
      {
        params: {
          SegmentoId: segmentId,
        },
      },
    );
  }

  static getMccByCnae(cnae) {
    return httpService.get(
      'sgrintegration/simulador/relacao/cnae-x-mcc',
      {
        params: {
          Cnae: cnae,
        },
      },
    );
  }

  static listCnaeByStoreDocument(document) {
    return httpService.get(
      `sgrintegration/loja/cnae-by-document/${document}`,
    );
  }
}
